import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

export interface BaseTipInfoState {
  visible: boolean;
  title: string;
  message: string;
  saveText: string;
}

const localBaseInfo = LocalStore.getValue<BaseTipInfoState>('BASE_TIP_INFO') || {};

export const baseTipInfo: BaseTipInfoState = {
  visible: false,
  title: '系统提示',
  message: '',
  saveText: '',
  ...localBaseInfo
};

export const setBaseTipInfo: (payload: BaseTipInfoState) => IAction<BaseTipInfoState> = (
  payload: BaseTipInfoState
) => ({
  type: 'setBaseTipInfo',
  payload
});

const baseTipReducer: Reducer<BaseTipInfoState, IAction<any>> = (state = baseTipInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setBaseTipInfo':
      LocalStore.setValue('BASE_TIP_INFO', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default baseTipReducer;
